import {
  Box,
  Button,
  Grid,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@mui/material";
import React from "react";
import StarRoundedIcon from "@mui/icons-material/StarRounded";
import CalendarTodayRoundedIcon from "@mui/icons-material/CalendarTodayRounded";

const NewRelease = () => {
  return (
    <Grid container sx={{ marginLeft: "3%", marginTop: "3%" }} spacing={2}>
      <Grid
        item
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          flex: "100%",
          color: "#2f6df6",
        }}
      >
        <Typography variant="h6">NEW RELEASES</Typography>
        <Button sx={{ background: "transparent", border: "none" }}>
          View All
        </Button>
      </Grid>
      <Grid
        item
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          flex: "100%",
          backgroundColor: "black",
          margin: "5px",
        }}
      >
        <Box sx={{ display: "flex", flexDirection: "row", padding: "5px" }}>
          <Box
            sx={{
              width: "60px",
              backgroundColor: "#2a2e4c",
              height: "60px",
              borderRadius: "5px",
            }}
          >
            <Typography></Typography>
          </Box>
          <Box>
            <Typography sx={{ marginLeft: "15px" }}>Metaspets</Typography>
            <List>
              <ListItem>
                <ListItemIcon>
                  <StarRoundedIcon sx={{ color: "yellow" }} />
                </ListItemIcon>
                <ListItemText>
                  <Typography sx={{ fontSize: "14px", color: "gray" }}>
                    5.0
                  </Typography>
                </ListItemText>
              </ListItem>
            </List>
          </Box>
        </Box>
        <Box>
          <List>
            <ListItem>
              <ListItemIcon>
                <CalendarTodayRoundedIcon sx={{ color: "gray" }} />
              </ListItemIcon>
              <ListItemText>
                <Typography sx={{ color: "gray" }}>29 Jun 2022</Typography>
              </ListItemText>
            </ListItem>
          </List>
        </Box>
      </Grid>
      <Grid
        item
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          flex: "100%",
          backgroundColor: "black",
          margin: "5px",
        }}
      >
        <Box sx={{ display: "flex", flexDirection: "row", padding: "5px" }}>
          <Box
            sx={{
              width: "60px",
              backgroundColor: "#2a2e4c",
              height: "60px",
              borderRadius: "5px",
            }}
          >
            <Typography></Typography>
          </Box>
          <Box>
            <Typography sx={{ marginLeft: "15px" }}>Metaspets</Typography>
            <List>
              <ListItem>
                <ListItemIcon>
                  <StarRoundedIcon sx={{ color: "yellow" }} />
                </ListItemIcon>
                <ListItemText>
                  <Typography sx={{ fontSize: "14px", color: "gray" }}>
                    5.0
                  </Typography>
                </ListItemText>
              </ListItem>
            </List>
          </Box>
        </Box>
        <Box>
          <List>
            <ListItem>
              <ListItemIcon>
                <CalendarTodayRoundedIcon sx={{ color: "gray" }} />
              </ListItemIcon>
              <ListItemText>
                <Typography sx={{ color: "gray" }}>29 Jun 2022</Typography>
              </ListItemText>
            </ListItem>
          </List>
        </Box>
      </Grid>
      <Grid
        item
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          flex: "100%",
          backgroundColor: "black",
          margin: "5px",
        }}
      >
        <Box sx={{ display: "flex", flexDirection: "row", padding: "5px" }}>
          <Box
            sx={{
              width: "60px",
              backgroundColor: "#2a2e4c",
              height: "60px",
              borderRadius: "5px",
            }}
          >
            <Typography></Typography>
          </Box>
          <Box>
            <Typography sx={{ marginLeft: "15px" }}>Metaspets</Typography>
            <List>
              <ListItem>
                <ListItemIcon>
                  <StarRoundedIcon sx={{ color: "yellow" }} />
                </ListItemIcon>
                <ListItemText>
                  <Typography sx={{ fontSize: "14px", color: "gray" }}>
                    5.0
                  </Typography>
                </ListItemText>
              </ListItem>
            </List>
          </Box>
        </Box>
        <Box>
          <List>
            <ListItem>
              <ListItemIcon>
                <CalendarTodayRoundedIcon sx={{ color: "gray" }} />
              </ListItemIcon>
              <ListItemText>
                <Typography sx={{ color: "gray" }}>29 Jun 2022</Typography>
              </ListItemText>
            </ListItem>
          </List>
        </Box>
      </Grid>
      <Grid
        item
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          flex: "100%",
          backgroundColor: "black",
          margin: "5px",
        }}
      >
        <Box sx={{ display: "flex", flexDirection: "row", padding: "5px" }}>
          <Box
            sx={{
              width: "60px",
              backgroundColor: "#2a2e4c",
              height: "60px",
              borderRadius: "5px",
            }}
          >
            <Typography></Typography>
          </Box>
          <Box>
            <Typography sx={{ marginLeft: "15px" }}>Metaspets</Typography>
            <List>
              <ListItem>
                <ListItemIcon>
                  <StarRoundedIcon sx={{ color: "yellow" }} />
                </ListItemIcon>
                <ListItemText>
                  <Typography sx={{ fontSize: "14px", color: "gray" }}>
                    5.0
                  </Typography>
                </ListItemText>
              </ListItem>
            </List>
          </Box>
        </Box>
        <Box>
          <List>
            <ListItem>
              <ListItemIcon>
                <CalendarTodayRoundedIcon sx={{ color: "gray" }} />
              </ListItemIcon>
              <ListItemText>
                <Typography sx={{ color: "gray" }}>29 Jun 2022</Typography>
              </ListItemText>
            </ListItem>
          </List>
        </Box>
      </Grid>
      <Grid
        item
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          flex: "100%",
          backgroundColor: "black",
          margin: "5px",
        }}
      >
        <Box sx={{ display: "flex", flexDirection: "row", padding: "5px" }}>
          <Box
            sx={{
              width: "60px",
              backgroundColor: "#2a2e4c",
              height: "60px",
              borderRadius: "5px",
            }}
          >
            <Typography></Typography>
          </Box>
          <Box>
            <Typography sx={{ marginLeft: "15px" }}>Metaspets</Typography>
            <List>
              <ListItem>
                <ListItemIcon>
                  <StarRoundedIcon sx={{ color: "yellow" }} />
                </ListItemIcon>
                <ListItemText>
                  <Typography sx={{ fontSize: "14px", color: "gray" }}>
                    5.0
                  </Typography>
                </ListItemText>
              </ListItem>
            </List>
          </Box>
        </Box>
        <Box>
          <List>
            <ListItem>
              <ListItemIcon>
                <CalendarTodayRoundedIcon sx={{ color: "gray" }} />
              </ListItemIcon>
              <ListItemText>
                <Typography sx={{ color: "gray" }}>29 Jun 2022</Typography>
              </ListItemText>
            </ListItem>
          </List>
        </Box>
      </Grid>
    </Grid>
  );
};

export default NewRelease;
